import { TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setShipsTime } from "src/redux/slices/generatorSlice";
import { Flex } from "src/styled";

import {
  formatShipsTimeDisplay,
  formatSignedHourOffset,
  isAllowedShipsTimeOffsetInput,
  parseShipsTimeOffset,
} from "./NMEAAutomationModal.utils";

interface NMEAShipsTimeOffsetInputProps {
  shipTimeFieldIds: string[];
}

const NMEAShipsTimeOffsetInput = ({
  shipTimeFieldIds,
}: NMEAShipsTimeOffsetInputProps) => {
  const dispatch = useDispatch();
  const { setValue } = useFormContext();
  const shipsTime = useSelector(s => s.generatorSlice.lbentry.shipsTime);
  const [shipsTimeInput, setShipsTimeInput] = useState("");
  const [isEditingShipsTime, setIsEditingShipsTime] = useState(false);

  useEffect(() => {
    if (isEditingShipsTime) return;

    setShipsTimeInput(formatSignedHourOffset(shipsTime));
  }, [isEditingShipsTime, shipsTime]);

  const applyShipsTimeOffset = (value: string) => {
    if (value === "") {
      dispatch(setShipsTime(null));
      shipTimeFieldIds.forEach(fieldId => {
        setValue(fieldId, "");
      });
      return;
    }

    const parsed = parseShipsTimeOffset(value);
    if (parsed !== null) {
      const formattedValue = formatShipsTimeDisplay(parsed);
      dispatch(setShipsTime(parsed));
      shipTimeFieldIds.forEach(fieldId => {
        setValue(fieldId, formattedValue);
      });
    }
  };

  const handleShipsTimeInputChange = (value: string) => {
    if (!isAllowedShipsTimeOffsetInput(value)) return;

    setShipsTimeInput(value);
    applyShipsTimeOffset(value);
  };

  const handleShipsTimeInputBlur = () => {
    setIsEditingShipsTime(false);

    const parsed = parseShipsTimeOffset(shipsTimeInput);
    if (parsed !== null) {
      setShipsTimeInput(formatSignedHourOffset(parsed));
      return;
    }

    if (shipsTimeInput === "") {
      return;
    }

    setShipsTimeInput(formatSignedHourOffset(shipsTime));
  };

  return (
    <Flex justify="flex-start">
      <TextInput
        label="Ships Time Offset"
        value={shipsTimeInput}
        onFocus={() => setIsEditingShipsTime(true)}
        onChange={event =>
          handleShipsTimeInputChange(event.currentTarget.value)
        }
        onBlur={handleShipsTimeInputBlur}
        placeholder="-12 to +14"
        w={220}
      />
    </Flex>
  );
};

export default NMEAShipsTimeOffsetInput;
